var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/24x24/ico_clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consumer_tablet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "107_protection_extras",
    transform: "translate(-985.000000, -567.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(983.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004,12.0001 C20.0004,7.58174729 16.4184778,4.0001 12.0004,4.0001 C7.58168475,4.0001 4.0004,7.58138475 4.0004,12.0001 C4.0004,16.4181778 7.58204729,20.0001 12.0004,20.0001 C16.4181153,20.0001 20.0004,16.4178153 20.0004,12.0001 Z M22.0004,12.0001 C22.0004,17.5223847 17.5226847,22.0001 12.0004,22.0001 C6.47744343,22.0001 2.0004,17.522713 2.0004,12.0001 C2.0004,6.47681525 6.47711525,2.0001 12.0004,2.0001 C17.523013,2.0001 22.0004,6.47714343 22.0004,12.0001 Z M15.7075068,14.2929932 L14.2932932,15.7072068 L11.0004,12.4143136 L11.0004,6.0001 L13.0004,6.0001 L13.0004,11.5858864 L15.7075068,14.2929932 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_clock.31be2dd902386d326f2805f6114add4f.svg";